import React, { useEffect } from 'react';

import Content from '@/Layouts/containers/Content';
import { usePageHeader } from '@/Components/AppHeader/AppHeader';
import pageViewedAnalytics, { PageName } from '@/Analytics/Page';

import classNames from 'classnames';
import styles from './styles.module.scss';

interface Props {
  className?: string;
}

// TODO: Need design
const NotFound: React.FC<Props> = ({ className }) => {
  usePageHeader({
    title: 'Page Not Found',
  });
  useEffect(() => {
    pageViewedAnalytics(PageName.NotFound);
  }, []);

  return <Content className={classNames(className, styles.notFound)}>Page Not Found</Content>;
};

export default NotFound;
